export default "__VITE_ASSET__EMy0rDfK__"